import { Component, Input } from "@angular/core";
import { LanguageService } from "@app/service/language.service";

@Component({
    selector: "app-export-area-loader",
    templateUrl: "./export-area-loader.component.html",
    styleUrls: ["./export-area-loader.component.scss"],
    standalone: true,
})
export class ExportAreaLoaderComponent {
    @Input() text!: string;

    constructor(
        public lang: LanguageService
    ) {}
}
